import { render, staticRenderFns } from "./pacienteInfoOs.vue?vue&type=template&id=a38b58f0&scoped=true"
import script from "./pacienteInfoOs.vue?vue&type=script&lang=js"
export * from "./pacienteInfoOs.vue?vue&type=script&lang=js"
import style0 from "./pacienteInfoOs.vue?vue&type=style&index=0&id=a38b58f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38b58f0",
  null
  
)

export default component.exports